import { UTBReportDataGroup } from '@e-origin/shared';

export interface TaxSummary {
  taxType: string;
  total: number;
}

export const computeResources = (group: UTBReportDataGroup): TaxSummary[] => {
  const taxesMap = new Map<string, TaxSummary>();
  group.declarations.forEach((declaration) => {
    declaration.calculationResultsItems.forEach((item) => {
      const currentValue = taxesMap.get(item.taxType) || {
        taxType: item.taxType,
        total: 0,
      };
      currentValue.total += item.payableTaxAmount || 0;
      taxesMap.set(item.taxType, currentValue);
    });
  });

  return Array.from(taxesMap.values());
};
